export const GET_PENDING_VOUCHERS_START =
  'GET_PENDING_VOUCHERS_START';
export const GET_PENDING_VOUCHERS_ERROR =
  'GET_PENDING_VOUCHERS_ERROR';
export const GET_PENDING_VOUCHERS_SUCCESS =
  'GET_PENDING_VOUCHERS_SUCCESS';
